/* CWF PL-C launch — 2D camera-pan walk.
   A fixed cool-white beam stays centered while a dark house translates beneath it.
   Each room is a screen-sized slide; the camera travels down -> left -> down, then the
   sticky scene releases into the rest of the page. Self-contained (no libraries).
   Ported from the prototype; scoped to .cwf-plc, runs on its own page (no SPA active-check). */
(function(){
  function init(){
    const page=document.querySelector('.cwf-plc'); if(!page)return;
    document.documentElement.classList.add('cwf-plc-scroll-page');
    const overflowMode=(window.CSS&&CSS.supports&&CSS.supports('overflow: clip'))?'clip':'visible';
    document.documentElement.style.overflowX=overflowMode;
    document.body.style.overflowX=overflowMode;
    const walk=page.querySelector('.walk'), house=page.querySelector('.house');
    const rooms=[...page.querySelectorAll('.wroom')], routeP=page.querySelector('.route path');
    const floorplan=page.querySelector('.floorplan');
    const fpWalls=floorplan&&floorplan.querySelector('.fp-walls'), fpDoors=floorplan&&floorplan.querySelector('.fp-doors'), fpShadows=floorplan&&floorplan.querySelector('.fp-shadows');
    const cone=page.querySelector('.beam-cone');
    if(!walk||!house||!rooms.length)return;
    const WP=[[0,-.18],[0,0],[0,1],[-1.3,1],[-1.3,2]];
    const LEAD=1;
    let pts=[],segLen=[],total=0,vw=0,vh=0,curAng=180,bands=[],sumLen=0,targetD=0,renderD=0,raf=0;
    const DWELL=0.78, TRAVEL=1.18, MINTRAVEL=0.82, LEADTRAVEL=0.18, NROOMS=4, STARTDWELL=0;
    function wallLine(x1,y1,x2,y2){return '<path class="fp-wall" d="M'+x1.toFixed(1)+' '+y1.toFixed(1)+' L'+x2.toFixed(1)+' '+y2.toFixed(1)+'"/>';}
    function doorLine(x1,y1,x2,y2){return '<path class="fp-door" d="M'+x1.toFixed(1)+' '+y1.toFixed(1)+' L'+x2.toFixed(1)+' '+y2.toFixed(1)+'"/>';}
    function roomShadow(cx,cy,w,h){return '<rect class="fp-shadow" x="'+(cx-w/2).toFixed(1)+'" y="'+(cy-h/2).toFixed(1)+'" width="'+w.toFixed(1)+'" height="'+h.toFixed(1)+'"/>';}
    function rectWalls(cx,cy,w,h,gaps){
      const x1=cx-w/2,x2=cx+w/2,y1=cy-h/2,y2=cy+h/2,parts=[];
      const addSide=(side,a,b,door)=>{
        const gap=door?Math.max(70,door.size):0,mid=door?(door.at||0):0;
        if(side==='top'||side==='bottom'){
          const y=side==='top'?y1:y2, g1=cx+mid-gap/2, g2=cx+mid+gap/2;
          parts.push(wallLine(x1,y,Math.max(x1,g1),y),wallLine(Math.min(x2,g2),y,x2,y));
        }else{
          const x=side==='left'?x1:x2, g1=cy+mid-gap/2, g2=cy+mid+gap/2;
          parts.push(wallLine(x,y1,x,Math.max(y1,g1)),wallLine(x,Math.min(y2,g2),x,y2));
        }
      };
      addSide('top',x1,x2,gaps.top);addSide('right',y1,y2,gaps.right);addSide('bottom',x1,x2,gaps.bottom);addSide('left',y1,y2,gaps.left);
      return parts.join('');
    }
    function drawFloorplan(){
      if(!fpWalls||!fpDoors||!fpShadows)return;
      const rw=Math.min(vw*.74,640), rh=Math.min(vh*.62,500), door=Math.min(170,Math.max(104,Math.min(vw,vh)*.18));
      const entry=pts[LEAD], hall=pts[LEAD+1], living=pts[LEAD+2], master=pts[LEAD+3];
      const specs=[
        {p:entry,g:{top:{size:door*.95},bottom:{size:door}}},
        {p:hall,g:{top:{size:door},left:{size:door*.9}}},
        {p:living,g:{right:{size:door*.9},bottom:{size:door}}},
        {p:master,g:{top:{size:door},bottom:{size:door*.95}}}
      ];
      fpShadows.innerHTML=specs.map(s=>roomShadow(s.p[0],s.p[1],rw,rh)).join('');
      fpWalls.innerHTML=specs.map(s=>rectWalls(s.p[0],s.p[1],rw,rh,s.g)).join('')
        + wallLine(entry[0]-door/2,entry[1]+rh/2,entry[0]-door/2,hall[1]-rh/2)
        + wallLine(entry[0]+door/2,entry[1]+rh/2,entry[0]+door/2,hall[1]-rh/2)
        + wallLine(living[0]+rw/2,hall[1]-door*.45,hall[0]-rw/2,hall[1]-door*.45)
        + wallLine(living[0]+rw/2,hall[1]+door*.45,hall[0]-rw/2,hall[1]+door*.45)
        + wallLine(living[0]-door/2,living[1]+rh/2,living[0]-door/2,master[1]-rh/2)
        + wallLine(living[0]+door/2,living[1]+rh/2,living[0]+door/2,master[1]-rh/2);
      fpDoors.innerHTML=doorLine(entry[0]-door*.28,entry[1]+rh/2,entry[0]+door*.28,entry[1]+rh/2)
        + doorLine(hall[0]-rw/2,hall[1]-door*.24,hall[0]-rw/2,hall[1]+door*.24)
        + doorLine(living[0]+rw/2,living[1]-door*.24,living[0]+rw/2,living[1]+door*.24)
        + doorLine(living[0]-door*.28,living[1]+rh/2,living[0]+door*.28,living[1]+rh/2)
        + doorLine(master[0]-door*.28,master[1]-rh/2,master[0]+door*.28,master[1]-rh/2)
        + doorLine(master[0]-door*.28,master[1]+rh/2,master[0]+door*.28,master[1]+rh/2);
    }
    function layout(){
      vw=innerWidth; vh=innerHeight;
      pts=WP.map(([x,y])=>[x*vw,y*vh]);
      segLen=[];total=0;const cum=[0];
      for(let i=1;i<pts.length;i++){const L=Math.hypot(pts[i][0]-pts[i-1][0],pts[i][1]-pts[i-1][1]);segLen.push(L);total+=L;cum[i]=total;}
      rooms.forEach((r,i)=>{const w=pts[i+LEAD];r.style.setProperty('--rx',w[0]+'px');r.style.setProperty('--ry',w[1]+'px');});
      if(routeP)routeP.setAttribute('d','M'+pts.map(p=>p[0].toFixed(1)+' '+p[1].toFixed(1)).join(' L'));
      drawFloorplan();
      bands=[];let s=0;
      for(let i=0;i<pts.length;i++){
        const dwell=(i===0)?vh*STARTDWELL:((i>=LEAD&&i<LEAD+NROOMS)?vh*DWELL:0);
        if(dwell>0){bands.push({s0:s,s1:s+dwell,d0:cum[i],d1:cum[i]});s+=dwell;}
        if(i<pts.length-1){
          const travelScale=i<LEAD?LEADTRAVEL:TRAVEL;
          const minTravel=i<LEAD?vh*.12:vh*MINTRAVEL;
          const tl=Math.max(minTravel,segLen[i]*travelScale);
          bands.push({s0:s,s1:s+tl,d0:cum[i],d1:cum[i+1]});s+=tl;
        }
      }
      sumLen=s;
      walk.style.height=(sumLen+vh)+'px';
    }
    function distAt(s){
      s=Math.max(0,Math.min(sumLen,s));
      for(const b of bands){
        if(s<=b.s1||b===bands[bands.length-1]){
          let t=(b.s1>b.s0)?(s-b.s0)/(b.s1-b.s0):0;t=Math.max(0,Math.min(1,t));t=t*t*t*(t*(t*6-15)+10);
          return b.d0+(b.d1-b.d0)*t;
        }
      }
      return total;
    }
    function cameraAt(d){
      d=Math.max(0,Math.min(total,d));
      for(let i=0;i<segLen.length;i++){
        if(d<=segLen[i]||i===segLen.length-1){const t=segLen[i]?d/segLen[i]:0;return [pts[i][0]+(pts[i+1][0]-pts[i][0])*t,pts[i][1]+(pts[i+1][1]-pts[i][1])*t];}
        d-=segLen[i];
      }
      return pts[pts.length-1];
    }
    function headingAt(d){
      const D=Math.min(vw,vh)*0.5;
      const a=cameraAt(d-D), b=cameraAt(d+D);
      const hx=b[0]-a[0], hy=b[1]-a[1];
      if(Math.hypot(hx,hy)<1) return curAng;
      let ang=Math.atan2(hx,-hy)*180/Math.PI;
      while(ang-curAng>180) ang-=360;
      while(ang-curAng<-180) ang+=360;
      return ang;
    }
    function applyFrame(d,snap){
      const cam=cameraAt(d), cx=cam[0], cy=cam[1];
      house.style.transform='translate3d('+(-cx)+'px,'+(-cy)+'px,0)';
      const desired=headingAt(d);
      if(snap){curAng=desired;}
      else{let delta=desired-curAng;while(delta>180)delta-=360;while(delta<-180)delta+=360;curAng+=delta*0.16;}
      if(cone)cone.style.setProperty('--ang',curAng.toFixed(2)+'deg');
      const isMobile=vw<761;
      const half=isMobile?vh*0.72:Math.min(vw,vh)*0.74;
      const litR=isMobile?vh*0.34:Math.min(vw,vh)*0.39;
      rooms.forEach((r,i)=>{
        const w=pts[i+LEAD];const dist=Math.hypot(cx-w[0],cy-w[1]);
        let o=1-dist/half;o=Math.max(0,Math.min(1,o));o=o*o*(3-2*o);
        const inner=r.querySelector('.rinner');
        if(inner){
          const dx=(dist?w[0]-cx:0)/Math.max(1,dist), dy=(dist?w[1]-cy:0)/Math.max(1,dist);
          const drift=(1-o)*18;
          inner.style.opacity=o.toFixed(3);
          inner.style.transform='translate3d('+(-dx*drift).toFixed(1)+'px,'+(-dy*drift).toFixed(1)+'px,0) scale('+(0.985+o*0.015).toFixed(3)+')';
        }
        r.classList.toggle('lit',dist<litR);
      });
    }
    function requestRender(){if(!raf)raf=requestAnimationFrame(render);}
    function render(){
      raf=0;
      const delta=targetD-renderD;
      renderD+=delta*0.115;
      if(Math.abs(delta)<0.35)renderD=targetD;
      applyFrame(renderD,false);
      if(Math.abs(targetD-renderD)>0.2)requestRender();
    }
    function sync(){targetD=distAt(scrollY-walk.offsetTop);requestRender();}
    window.__plcLaunch=function(){layout();targetD=distAt(scrollY-walk.offsetTop);renderD=targetD;applyFrame(renderD,true);};
    addEventListener('scroll',sync,{passive:true});
    addEventListener('resize',()=>{layout();targetD=distAt(scrollY-walk.offsetTop);renderD=targetD;applyFrame(renderD,true);});
    layout();targetD=distAt(scrollY-walk.offsetTop);renderD=targetD;applyFrame(renderD,true);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);
  else init();
})();
